export default __webpack_public_path__ + "static/media/172.0b91b530.gif";